import useTranslation from '@CS/hooks/useTranslation';
import { useDashboardTranslation } from '@/hooks';
import Content from './content';

import {
  Title,
  Button,
  CloseButton,
  Description,
  PopupOverlay,
  PopupContent
} from './WelcomePopup.styles';

type WelcomePopupProps = {
  onClose: () => void;
};

export const WelcomePopup = ({ onClose }: WelcomePopupProps) => {
  const fallback = useTranslation(Content);
  const t = useDashboardTranslation();
  const title = t('Family_onboarding_pop_up_title', fallback.title);
  const description = t(
    'Family_onboarding_pop_up_description',
    fallback.description
  );
  const button = t('Family_onboarding_pop_up_cta', fallback.button);

  return (
    <PopupOverlay>
      <PopupContent>
        <CloseButton onClick={onClose} />
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Button onClick={onClose}>{button}</Button>
      </PopupContent>
    </PopupOverlay>
  );
};
